<template>
    <div class="container">
        <div class="section" v-for="(item,index) in sectionData" :key="index" :id="'section_' + index">
            <div class="img-container" :class="{'padding-container':item.customize}">
                <img class="img"  v-if="item.type==='img' || item.type==='btn'" v-lazy="item.url"
                    :class="{'btn-style':item.type==='btn'}"
                >
                <div v-if="item.type==='btn'" class="btn-wrap" @click="toBuy('了解更多项目详情')"></div>
                <div  v-if="item.type==='swiper'" class="swiper-main">
                    <div class="swiper-container current-wrap">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide current-slider" v-for="(item,index) in swiperList" :key="index">
                                <img :src="item">
                            </div>
                        </div>
                        <div class="swiper-pagination current-pagination" />
                    </div>
                 </div>
            </div>
        </div>
        <div class="footer" @click="toBuy('立即咨询')">
            <img src="https://s21.lgstatic.com/growth/activity/20211104/1636000795211.png" alt="">
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    import 'swiper/dist/css/swiper.min.css';
    export default {
        data() {
            return {
                sectionData:[
                    {url:'https://s21.lgstatic.com/growth/activity/20211103/1635913621348.png',type:'img'},
                    {url:'https://s20.lgstatic.com/growth/activity/20211103/1635921331319.png',type:'img'},
                    {url:'',type:'swiper'},
                    {url:'https://s21.lgstatic.com/growth/activity/20211103/1635922057172.png',type:'img'},
                    {url:'https://s21.lgstatic.com/growth/activity/20211117/1637140338676.jpeg',type:'btn'},
                    {url:'https://s21.lgstatic.com/growth/activity/20211105/1636080923796.png',type:'img'},
                    {url:'https://s20.lgstatic.com/growth/activity/20211103/1635924320111.png',type:'img'},
                    {url:'https://s20.lgstatic.com/growth/activity/20211103/1635924352536.png',type:'img'},
                    {url:'https://s21.lgstatic.com/growth/activity/20211103/1635924378348.png',type:'img'},
                    // {url:'https://s21.lgstatic.com/growth/activity/20211103/1635924416477.png',type:'img'}
                ],
                swiperList:[
                    'https://s20.lgstatic.com/growth/activity/20211103/1635924636572.png',
                    'https://s20.lgstatic.com/growth/activity/20211103/1635926664839.png',
                    'https://s20.lgstatic.com/growth/activity/20211103/1635926828285.png',
                    'https://s20.lgstatic.com/growth/activity/20211103/1635926844048.png'
                ]
            
            }
        },
        mounted () {
            this.renderSwipers();
            setTimeout(()=>{
                this.eduPlatTrack('WebView', { page_id: 'c1tc6'});
            },200);
        },
        methods: {
            toBuy(name) {
                this.eduPlatTrack('WebButtonClick', {
                    'page_id': 'c1tc6',
                    'button_name': name
                });
                setTimeout(() => {
                   location.href="https://kaiwu.lagou.com/crmForm/form/bb9e0d0e08dd4008a967df3bab29951e";
                }, 200);
            },
            renderSwipers() {
                let option = {
                    speed: 300,
                    autoplay: 3000,
                    loop: true,
                    autoplayDisableOnInteraction: false,
                    slidesPerView: 'auto',
                };
                const swiper = new Swiper('.current-wrap', option);
            },
        },
    }
</script>

<style lang="less" scoped>
.container {
    user-select: none;
    width: 100%;
    background: #F2F9FF;
    padding-bottom: 172px;
    .section {
        position: relative;
        width: 100%;
        background: #f8f8f8;
        .img {
            width: 100%;
            display: block;
        }
        .img-container{
            position: relative;
            .btn-style{
               cursor: pointer;
            }
            .btn-wrap{
                position: absolute;
                bottom: 20px;
                left: 23%;
                width: 400px;
                height: 100px;
            }
        }
        .padding-container{
            min-height: 200px;
        }
        .activityImg {
            position: absolute;
            z-index: 11;
            top: 0;
            right: 0;
            width: 157px;
            height: 158px;
            img {
                width: 100%;
            }
        }
        .current-container {
            width: 100%;
            position: absolute;
            height: 202px;
            bottom: 230px;
            .current-wraps {
                width: 582px;
                position: absolute;
                padding-left: 10px;
                .current-box {
                    width:100% !important;
                    margin-left: 20px;
                    img {
                        width: 100%;
                    }
                }
            }
        }
        .wrap {
            width: 690px;
            height: 647px;
            .swiper-wrapper {
                width:100% !important;
                img {
                    width: 100%;
                }
            }
        }
    }
    .swiper-main {
        width: 100%;
        height: 8.267rem;
        background-size: 100% 100%;
        box-sizing: border-box;
        background: #f8f8f8;
    }
/deep/ .current-wrap {
    height: 100%;
    .swiper-wrapper {
        height: 100%;
        .swiper-slide {
            width: 100%;
            height: 100%;
            img {
                width: 100%;
            }
        }
    }
    .swiper-pagination-bullet{
        width: 0.173rem;
        height: 0.173rem;
        background: rgba(240,114,52,.4);
        border-radius: 50%;
        opacity: 1;
        &-active{
            border-radius: 0.173rem;
            width: 0.48rem;
            background: #F07234;
        }
    }
}
    .footer{
        width: 100%;
        position: fixed;
        height: 172px;
        bottom: 0;
        left: 0;
        z-index: 10;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
</style>